import { IntroSubContent } from "../components/pages/intro/intro.model"
import { Injectable } from "@angular/core"

@Injectable({
  providedIn: "root",
})
export class BostonMaRegion {

  localVideo(): IntroSubContent {
    return {
      image: {
        altText: "",
        srcDarkMode: "",
        srcLightMode: "",
        style: {},
      },
      video: {},
      style: {},
      contents: [],
      subTitle: "",
      value: "",
    }
  }

  brandHeader(): IntroSubContent {
    return {
      contents: [],
      video: {},
      title: "Boston",
      subTitle: "presented in partnership with",
      image: {
        altText: "NAR logo",
        srcDarkMode: "/assets/regions/boston_ma/Boston-Logo.png",
        srcLightMode: "/assets/regions/boston_ma/Boston-Logo.png",
        style: {},
      },
      style: {
        width: "300px",
      },
    }
  }

}
